import React, { useEffect, useState } from "react";
import Breadcrumbs from "../layout/breadcrumb";
import DprHeader from "../layout/dprHeader";
import { dprs } from "../../assets/dpr";
import Close from "../../assets/Images/close.png";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import leftArrow from "../../assets/Images/left-arrow.png";
import rightArrow from "../../assets/Images/right-arrow.png";
import NotFound from "../../assets/Icons/nodpr.png";
import CreateDpr from "../../assets/Icons/create-dpr.png";
import Proceed from "../../assets/Icons/proceed.png";
import { useLocation, useNavigate } from "react-router-dom";
import { DPR_API } from "../../services/apiCalls/dprApiCalls";
import { toast } from "react-toastify";

export default function Dprlist() {
  const navigate = useNavigate();
  const location = useLocation();
  const pro = location.state || {};

  const [dprDatas, setdprDatas] = useState([]);
  const [loading, setLoading] = useState(true); // Loading state
  const [open, setOpen] = useState(false);
  const onOpenModal = () => setOpen(true);
  const onCloseModal = () => setOpen(false);
  const [currentPage, setCurrentPage] = useState(1);

  const getDpr = async () => {
    try {
      let state = JSON.parse(localStorage.getItem("state"));

      let obj = {
        EmailID: state.user.Email,
        ProjectGUID: pro?.ProjectGUID,
      };
      const dpr = await DPR_API.GetProjectWorkPackage(obj);
      setdprDatas(dpr.WorkPackagelList || []);
    } catch (error) {
      toast.error("Error fetching DPR data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getDpr();
  }, []);

  const rowsPerPage = 10;

  const totalPages = Math.ceil(dprDatas.length / rowsPerPage);

  const handleClick = (page) => {
    setCurrentPage(page);
  };

  const paginatedData = dprDatas.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  return (
    <React.Fragment>
      <div className="pb-5">
        <Breadcrumbs title="DPR List" menu="" link="DPR List" />
        <DprHeader project={pro} />
        {loading ? (
          <></>
        ) : paginatedData.length > 0 ? (
          <>
            <div className="table-container">
              <table className="custom-table">
                <thead className="table-header">
                  <tr>
                    <th>DPR Name</th>
                    <th>Location</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {paginatedData.map((row, index) => (
                    <tr key={index}>
                      <td id="elps" title={row.WorkPackageName}>
                        {row.WorkPackageName}
                      </td>
                      <td id="elps" title={pro.Location}>
                        {pro.Location}
                      </td>
                      <td>
                        <button
                          className="btn btn-primary"
                          onClick={() => {
                            let obj = { ...pro, ...row };
                            navigate("/dpr", {
                              state: obj,
                            });
                          }}
                        >
                          View Work Breakdown
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div
                className="pagination"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "10px 15px",
                }}
              >
                <div style={{ fontSize: "14px", whiteSpace: "nowrap" }}>
                  Showing{" "}
                  {Math.min(
                    (currentPage - 1) * rowsPerPage + 1,
                    dprDatas.length
                  )}{" "}
                  to {Math.min(currentPage * rowsPerPage, dprDatas.length)} of{" "}
                  {dprDatas.length} entries
                </div>
                <div
                  className="pagination-buttons"
                  style={{
                    fontSize: "14px",
                    display: "flex",
                    justifyContent: "flex-end",
                    width: "100%",
                    gap: "5px",
                  }}
                >
                  <button
                    onClick={() => handleClick(Math.max(1, currentPage - 1))}
                    disabled={currentPage === 1}
                    style={{
                      background: "none",
                      border: "none",
                      cursor: currentPage === 1 ? "not-allowed" : "pointer",
                    }}
                  >
                    <img
                      src={leftArrow}
                      alt="Previous"
                      height="11px"
                      width="7px"
                      style={{ opacity: currentPage === 1 ? 0.5 : 1 }}
                    />
                  </button>
                  {[...Array(totalPages)].map((_, i) => (
                    <button
                      key={i}
                      onClick={() => handleClick(i + 1)}
                      style={{
                        background:
                          currentPage === i + 1 ? "#00B69B" : "transparent",
                        color: currentPage === i + 1 ? "#fff" : "#000",
                        border: "none",
                        borderRadius: "50%",
                        width: "30px",
                        height: "30px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                      }}
                    >
                      {i + 1}
                    </button>
                  ))}

                  <button
                    onClick={() =>
                      handleClick(Math.min(totalPages, currentPage + 1))
                    }
                    disabled={currentPage === totalPages}
                    style={{
                      background: "none",
                      border: "none",
                      cursor:
                        currentPage === totalPages ? "not-allowed" : "pointer",
                    }}
                  >
                    <img
                      src={rightArrow}
                      alt="Next"
                      height="11px"
                      width="7px"
                      style={{ opacity: currentPage === totalPages ? 0.5 : 1 }}
                    />
                  </button>
                </div>
              </div>
            </div>
          </>
        ) : (
          <div className="card-none p-3">
            <div className="row" style={{ background: "white" }}>
              <div className="col-6" style={{ margin: "auto" }}>
                <div className="card-body">
                  <div style={{ textAlign: "center" }}>
                    <img src={NotFound} width={400} />
                  </div>
                  <div className="mt-4" style={{ textAlign: "center" }}>
                    <span
                      style={{
                        color: "rgba(47, 47, 47, 1)",
                        fontSize: 16,
                        fontWeight: 600,
                      }}
                    >
                      DPR has not been created yet
                    </span>
                  </div>
                  <div
                    className="d-flex justify-content-center mt-3 pb-4"
                    style={{ textAlign: "center" }}
                  >
                    <button className="d-flex create-btn">
                      <div>
                        <img src={CreateDpr} width={20} height={20} />
                      </div>
                      <div
                        className="my-1"
                        style={{
                          fontSize: 14,
                          fontWeight: 500,
                          marginLeft: 5,
                        }}
                        onClick={() => setOpen(true)}
                      >
                        Click to Create
                      </div>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      <Modal open={open} onClose={onCloseModal} center>
        <div className="d-flex justify-content-between">
          <div>
            <span className="allowcate">Create DPR</span>
          </div>
          <div>
            <img
              src={Close}
              width={20}
              onClick={() => {
                setOpen(false);
              }}
              style={{ cursor: "pointer" }}
            />
          </div>
        </div>
        <hr />
        <div
          style={{
            color: "rgba(50, 50, 50, 1)",
            fontSize: 18,
            fontWeight: 500,
          }}
        >
          Guideline
        </div>
        <div className="d-flex text-create mt-2">
          <div>1.</div>&nbsp;
          <div>
            Summaries the work completed, listing tasks finished, brief
            descriptions and location
          </div>
        </div>
        <div className="d-flex text-create mt-2">
          <div>2.</div>&nbsp;
          <div>
            Detail work in progress with tasks underway, completion percentages,
            and expected completion dates.
          </div>
        </div>
        <div className="d-flex text-create mt-2">
          <div>3.</div>&nbsp;
          <div>
            Detail work in progress with tasks underway, completion percentages,
            and expected completion dates.
          </div>
        </div>
        <div className="d-flex text-create mt-2">
          <div>4.</div>&nbsp;
          <div>
            Detail work in progress with tasks underway, completion percentages,
            and expected completion dates.
          </div>
        </div>
        <div className="d-flex text-create mt-2">
          <div>5.</div>&nbsp;
          <div>
            Detail work in progress with tasks underway, completion percentages,
            and expected completion dates.
          </div>
        </div>
        <div className="d-flex text-create mt-2">
          <div>6.</div>&nbsp;
          <div>
            Detail work in progress with tasks underway, completion percentages,
            and expected completion dates.
          </div>
        </div>
        <div class="form-check form-check-inline mt-2">
          <input
            class="form-check-input shadow-none"
            type="checkbox"
            id="inlineCheckbox1"
            value="option1"
          />
          <label class="form-check-label check-dpr" for="inlineCheckbox1">
            I have read the guidelines
          </label>
        </div>
        <div
          className="d-flex justify-content-center mt-3 pb-4"
          style={{ textAlign: "center" }}
        >
          <button className="d-flex proceed-btn">
            <div
              className="my-1"
              style={{ fontSize: 14, fontWeight: 500, marginLeft: 5 }}
            >
              Proceed
            </div>
            <div className="my-auto mx-1">
              <img src={Proceed} width={15} height={10} />
            </div>
          </button>
        </div>
      </Modal>
    </React.Fragment>
  );
}
